<template>
  <div class="page-fatture-acquisto-detail">
    <fatture-clienti-detail />
  </div>
</template>

<script>
import FattureClientiDetail from '@/components/ask/details/FattureAcquistoDetail.vue'

export default {
  name: 'ViewFattureAcquistoDetail',
  components: {
    FattureClientiDetail,
  },

  data() {
    return {
      pageName: 'FattureAcquistoDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
